import React, { useEffect } from 'react';
import AOS from 'aos';
import './skills.css';

const images = require.context('./icons', true, /\.png$/);
const imageNames = images.keys().map((path) => path.split('/').pop());

const Skills = () => {
	useEffect(() => {
		AOS.init({ duration: 1000 });
	}, []);

	// Generate rows dynamically
	const generateRows = (rowStructure, imageLength) => {
		let imageIndex = 0;
		const selectedImages = imageNames.slice(0, imageLength);

		return rowStructure.map((count, rowIndex) => {
			const rowImages = selectedImages.slice(imageIndex, imageIndex + count);
			imageIndex += count;

			return (
				<div key={rowIndex} className="skill_row">
					{rowImages.map((name, index) => (
						<div key={index} className="cell" data-aos="zoom-in-up" data-aos-offset="120">
							<img src={images(`./${name}`)} alt={name.replace('.png', '')} />
						</div>
					))}
				</div>
			);
		});
	};


	return (
		<div className='skillContainer'>
			<div className='text-2xl mb-14 font-bai'>
				<span className='text-neon font-extrabold' data-aos="zoom-in-left" data-aos-offset="120">&lt;</span>
				<span data-aos="zoom-in-up" data-aos-offset="120"> My Artists </span>
				<span className='text-neon font-extrabold' data-aos="zoom-in-right" data-aos-offset="120">/ &gt;</span>
			</div>
			<div className="skills">
				<span className="resp_skills">{generateRows([3, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3], 31)}</span>
				<span className="non_resp_skills">{generateRows([6, 7, 8, 7, 6], 34)}</span>
			</div>
		</div>
	);
};

export default Skills;
